import React, { useEffect, useState } from 'react';
import {
    Input,
    Stack,
    Breadcrumb,
    Divider,
    Panel,
    Container,
    SelectPicker,
    Button,
    DatePicker,
    Table,
    InputGroup,

} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import { Link } from 'react-router-dom';
import ugr from '@/UGRoute';


const data = [
    'L',
    'LCL',
    'MRP',
    'Cost',
    'Price',
].map(item => ({ label: item, value: item }));
const data2 = [
    'M',
    'FCL',
].map(item => ({ label: item, value: item }));
const data3 = [
    'MX',
].map(item => ({ label: item, value: item }));
const { Column, HeaderCell, Cell } = Table;

const EnquiryTracker = () => {


    return (
        <>
            <Container className='main'>
                <Stack className="table-toolbar" justifyContent="space-between">
                    <Stack direction='column' alignItems='flex-start'>

                        <Stack direction='column' alignItems='flex-start' >
                            <h3 className="title">Enquiry Tracker</h3>
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    <Link to={`/${ugr}/dashboard`}>
                                        Home</Link></Breadcrumb.Item>
                                <Breadcrumb.Item active>Enquiry</Breadcrumb.Item>
                            </Breadcrumb>
                        </Stack>


                        <Stack spacing={5} alignItems='flex-end'>
                            <Stack direction='column' alignItems='flex-start' >
                                <Stack><p>EnqDt From </p><p style={{ color: 'red' }}>*</p></Stack>
                                <DatePicker
                                    id="startDatePicker"
                                    format="dd/MM/yyyy"

                                />
                            </Stack>
                            <Stack direction='column' alignItems='flex-start' >
                                <Stack><p>EnqDt To </p><p style={{ color: 'red' }}>*</p></Stack>
                                <DatePicker
                                    id="endDatePicker"
                                    format="dd/MM/yyyy"

                                />
                            </Stack>

                            <Stack direction='column' alignItems='flex-start' >
                                <Stack><p>Buyer Name </p><p style={{ color: 'red' }}>*</p></Stack>
                                <SelectPicker data={[]} style={{ width: 200 }} />
                            </Stack><Stack direction='column' alignItems='flex-start' >
                                <label>Country</label>
                                <SelectPicker data={[]} style={{ width: 200 }} />
                            </Stack><Stack direction='column' alignItems='flex-start' >
                                <label>Enquiry No.</label>
                                <SelectPicker data={[]} style={{ width: 200 }} />
                            </Stack><Stack direction='column' alignItems='flex-start' >
                                <label>Merchant</label>
                                <SelectPicker data={[]} style={{ width: 200 }} />
                            </Stack>
                            <Button appearance='primary' color='cyan' >Save</Button>
                            <Button appearance='primary' color='orange'>Enquiry Print</Button>
                        </Stack>
                    </Stack>
                    <Stack>
                        <InputGroup inside >
                            <Input placeholder="Search" />
                            <InputGroup.Addon>
                                <SearchIcon />
                            </InputGroup.Addon>
                        </InputGroup>
                    </Stack>
                </Stack>
                <Divider className='divide' />
                <div className="row">
                    <Panel>
                        <Table height={420} data={[]}
                            rowHeight={60}
                            rowKey="id"
                            bordered
                            cellBordered

                        >
                            <Column width={80} align='center'>
                                <HeaderCell><b>S. NO</b></HeaderCell>
                                <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                            </Column>
                            <Column width={100} align='center'>
                                <HeaderCell><b>Enq No</b></HeaderCell>
                                <Cell />
                            </Column>
                            <Column width={100} align='center'>
                                <HeaderCell><b>Enq Dt</b></HeaderCell>
                                <Cell />
                            </Column>
                            <Column width={200} align='center'>
                                <HeaderCell><b>Merchant</b></HeaderCell>
                                <Cell />
                            </Column>
                            <Column width={200} align='center'>
                                <HeaderCell><b>Buyer Name</b></HeaderCell>
                                <Cell />
                            </Column>
                            <Column width={150} align='center'>
                                <HeaderCell><b>Country</b></HeaderCell>
                                <Cell />
                            </Column>
                            <Column width={180} align='center'>
                                <HeaderCell><b>Email</b></HeaderCell>
                                <Cell />
                            </Column>
                            <Column width={100} align='center'>
                                <HeaderCell><b>Visiting Card</b></HeaderCell>
                                <Cell />
                            </Column>
                            <Column width={100} align='center'>
                                <HeaderCell><b>Total Products</b></HeaderCell>
                                <Cell />
                            </Column>
                            <Column width={100} align='center'>
                                <HeaderCell><b>Offer Created</b></HeaderCell>
                                <Cell />
                            </Column>
                            <Column width={100} align='center'>
                                <HeaderCell><b>Action</b></HeaderCell>
                                <Cell />
                            </Column>
                        </Table>
                    </Panel>
                </div>

                <Stack className="copyright" justifyContent="flex-end" spacing={5} style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white', 'paddingRight': '16px' }}>
                    <p>© All Right Reserved. Product by </p><p> <a href="https://erpdaddy.com/" target="_blank">ERPDaddy Software Solution.</a></p>
                </Stack>
            </Container>
        </>
    )
}

export default EnquiryTracker;